import { Modal } from "react-bootstrap";
import BackgroundImage from "../../assets/images/notification/circle.png";
import confetti from "canvas-confetti";

const CircleNotification = ({ show, onHide, notification }) => {
  const handleClose = () => {
    onHide();
  };

  const goChat = () => {
    handleClose();
    confetti({
      particleCount: 200,
      spread: 180,
    });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header className="border-bottom-0" closeButton></Modal.Header>
      <Modal.Body className="text-primary">
        <img className="img img-fluid" src={BackgroundImage} alt="background" />
        <div className="text-captialize text-xxl fw-bold mt-3 mb-3">
          You've Completed the Circle! ✨
        </div>

        <div
          className="text-xs"
          dangerouslySetInnerHTML={{ __html: notification.text }}
        />
      </Modal.Body>
      <Modal.Footer className="border-top-0 pt-0">
        <buton className="btn btn-outline-success" onClick={handleClose}>
          Cancel
        </buton>
        <buton className="btn btn-success text-white" onClick={goChat}>
          Celebrate 🎉
        </buton>
      </Modal.Footer>
    </Modal>
  );
};

export default CircleNotification;
